import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import * as request from 'request';
import { showToastAlert } from '../Services/Utility';


class CreatePlanModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: props.showModal || false,
            selectedPlan: {},
            email: '',
            dataLimit: '',
            validity: '',
            proxies: '',
            dcAllocationLeft: {}
        };
        this.resiPlansOptions = props.resiPlansOptions;
        // this.userOptions = props.userOptions;
        this.planType = props.planType;
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal = () => {
        this.setState({
            showModal: false
        });
    }

    onChange = (e) => {
        e.persist();
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    planSelectionChange = (selectedOption) => {
        this.setState({ ['selectedPlan']: selectedOption || {} })
    };

    cancelClicked = async (event) => {
        this.closeModal();
    }

    saveClicked = async (event) => {
        event.preventDefault();

        if (!this.state.email.trim()) {
            return showToastAlert('Error', 'Please provide user email');
        }
        if (!this.state.selectedPlan.value) {
            return showToastAlert('Error', 'Please select plan');
        }

        if (this.planType === 'residential') {
            if (this.state.dataLimit.trim() === '') {
                return showToastAlert('Error', 'Please provide data limit');
            }
        }
        else {
            const split = this.state.selectedPlan.value.split(":");
            if (this.state.proxies.trim() === '') {
                return showToastAlert('Error', 'Please provide proxies length');
            }
            if (split[2] !== 'null' && this.state.dcAllocationLeft[split[2]] < parseInt(this.state.proxies)) {
                return showToastAlert('Error', `${parseInt(this.state.proxies)} proxies are not available in ${split[2]}`);
            }
        }

        if (this.state.validity.trim() === '') {
            return showToastAlert('Error', 'Please provide validity hours');
        }

        const validityHours = parseInt(this.state.validity);

        const idToken = await this.props.firebase.auth.currentUser.getIdToken(true);
        const split = this.state.selectedPlan.value.split(":");

        let data = {
            idToken: idToken,
            email: this.state.email.trim(),
            validityHours: validityHours,
            planID: split[1],
            subPlanID: split[0]
        }

        if (this.planType === 'residential') {
            data['dataLimitMB'] = parseInt(this.state.dataLimit);
        }
        else {
            data['numberOfProxies'] = parseInt(this.state.proxies);
            if (split[2] !== 'null') {
                data['servername'] = split[2];
            }
        }

        this.props.setLoading(true);
        const planRes = await this.createPlan(data, this.props.provider);
        this.props.setLoading(false);
        if (planRes !== null) {
            this.props.successCallback(planRes);
            showToastAlert('success', 'Plan created successfully');
            this.closeModal();
        }
    }

    createPlan = async (data, plantype) => {
        return new Promise((resolve, reject) => {
            let options = {
                method: 'POST',
                url: `${process.env.REACT_APP_API_URL}/${plantype}/createPlan`,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            return request(options, (error, response, body) => {
                let resData = body && JSON.parse(body);
                if (error || response.statusCode !== 200) {
                    let errorMessage = error ? error : resData ? resData.message : 'Error occurred while creating plan!';
                    showToastAlert('Error', errorMessage);
                    return resolve(null);
                } else {
                    return resolve(resData || {});
                }
            });
        });
    }

    render() {
        const { showModal } = this.state;
        return (
            <Modal
                isOpen={showModal}
                toggle={this.closeModal}
                onClosed={this.closeModal}
                className=""
                size="md"
                backdrop="static"
                centered
            >
                <div className="modal-body">
                    <div className="pop-bg-img">
                        <img src={require("assets/images/pop-bg.svg")} alt="" />
                    </div>
                    <button
                        type="button"
                        className="btn-close pop-close-btn"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={this.closeModal}
                    />
                    <div className="dash-head">
                        <img src={require("assets/images/purchase-head.svg")} alt="" /> <h4 className="mb-0">Create Plan</h4>
                    </div>

                    <div className={"form-field px-2 " + this.planType}>
                        <div className="form-group row mb-3 d-flex align-items-center">
                            <label htmlFor="email" className="col-sm-5 col-form-label py-0">User Email Id <span className='text-danger'>*</span></label>
                            <div className="col-sm-7">
                                <input type="email" className="form-control" id="email" onChange={this.onChange} value={this.state.email} placeholder='Enter email address' required />
                                {/* <Select className="select" id="user" options={this.userOptions} onChange={this.userSelectionChange} placeholder="Select user" /> */}
                            </div>
                        </div>
                        <div className="form-group row mb-3 d-flex align-items-center">
                            <label htmlFor="plan" className="col-sm-5 col-form-label py-0">Select Plan <span className='text-danger'>*</span></label>
                            <div className="col-sm-7">
                                <Select className="select" id="plan" options={this.resiPlansOptions} onChange={this.planSelectionChange} placeholder="Select plan" />
                            </div>
                        </div>
                        {
                            this.planType === 'residential' &&
                            <div className="form-group row mb-3 d-flex align-items-center">
                                <label htmlFor="dataLimit" className="col-sm-5 col-form-label py-0">Data Limit (MB) <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <input type="number" min={1} className="form-control" id="dataLimit" onChange={this.onChange} value={this.state.dataLimit} placeholder='Enter data limit' />
                                </div>
                            </div>
                        }
                        {
                            this.planType !== 'residential' &&
                            <div className="form-group row mb-3 d-flex align-items-center">
                                <label htmlFor="proxies" className="col-sm-5 col-form-label py-0">No. of Proxies <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <input type="number" min={1} className="form-control" id="proxies" onChange={this.onChange} value={this.state.proxies} placeholder='Enter proxies length' />
                                </div>
                            </div>
                        }
                        <div className="form-group row mb-2 d-flex align-items-center">
                            <label htmlFor="validity" className="col-sm-5 col-form-label py-0">Validity Hours <span className='text-danger'>*</span></label>
                            <div className="col-sm-7">
                                <input type="number" min={1} className="form-control" id="validity" onChange={this.onChange} value={this.state.validity} placeholder='Enter hour' />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 text-end">
                                <div className="d-inline-block mt-4 me-2">
                                    <a href="#" className="mb-3 px-5 cta-white" onClick={this.cancelClicked}>Cancel</a>
                                </div>
                                <div className="form-cta-btn d-inline-block mt-4">
                                    <a href="#" className="mb-3 px-5 text-light" style={{ 'boxShadow': '0px 6px 8px 3px #2c3d7926' }} onClick={this.saveClicked}>Create</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Modal>
        );
    }
}

export default withRouter(CreatePlanModal);